<template>
  <div class="lt">
    <div class="lt-bottom">
      <div class="lt-bt-item" v-for="(item, index) in defaultdata.slice(0, 8)" :key="index">
        <div class="lt-item-content">
          <img src="@/assets/temimg2/btimg.png" alt class="bt-bg-img" />
          <div class="item-num"> {{ item.value2 }}</div>
          <div class="lt-item-title ellipsis" :title="item.value1">{{ item.value1 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: "template.scope13",
  props: {
    vdata: {
      type: Array,
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      defaultdata: [
        { value1: '文本一', value2: "555" },
        { value1: '文本二', value2: "429687" },
        { value1: '文本三', value2: "4511" },
        { value1: '文本四', value2: '748' },
        { value1: '文本五', value2: '300' },
        { value1: '文本六', value2: '300' },
        { value1: '文本七', value2: '100' },
        { value1: '文本八', value2: '850' },
      ],
      valueMap: [
        { name: '名称', key: 'value1' },
        { name: '数值', key: 'value2' },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      config: {
      },
    }
  },

  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
  },
  methods: {
    ...methods,
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
          let vlist = Object.keys(item)
          let isdata = false
          vlist.forEach(del => {
            if (item[del] == undefined) {
              item[del] = ''
            } else if (del && item[del]) {
              isdata = true
            }
          })
          if (vlist.length && isdata) return item
        })
        this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    }
  },
};
</script>

<style scoped lang="scss">
// @font-face {
//   font-family: "Benmo-Ziyu";
//   src: url("../@/assets/temimg2/fonts/Benmo-Ziyu.woff2");
// }

.lt {
  width: 435px;
  height: 240px;
  display: flex;
  padding: 10px 0;
  position: relative;
  overflow: hidden;
}

.lt-bottom {
  width: 435px;
  height: 240px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 10px;
  // margin-left: 20px;
}

.lt-bt-item {
  width: 100px;
  height: 120px;
  // position: relative;
  margin: -10px 2px 0px;
}

.lt-item-content {
  width: 100%;
  height: 100%;
  // background: #000;
  display: flex;
  flex-direction: column;
  position: relative;
}

.lt-bt-item:nth-child(4n + 1) {
  margin-left: 0;

}

.lt-bt-item:nth-child(n+5) {
  margin-top: -20px;
}

.bt-bg-img {
  margin: 20px auto 0;
  // position: relative;
  width: 98px;
  height: 87px;
}

.bt-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 36px;
  top: 20px;
}

.lt-item-title {
  // margin: 50px auto 0;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -90%);
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #c4dff8;
  text-align: center;
  width: 95px;
  // line-height: 18px;
}

.item-num {
  // margin: -80px 0 0 30px;
  position: absolute;
  top: 34%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Benmo Ziyu;
  font-weight: 400;
  font-size: 20px;
  color: #b9eaff;
  // line-height: 20px;
  background: linear-gradient(0deg, #47bafa 0%, #ffffff 99.5849609375%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  z-index: 10;
}
</style>